// TODO - Documentar
import { useEffect, useRef, useState } from 'react'
import { VALUE_CHANGE_TIMEOUT } from '../../GlobalConstants'

function NumericVisualizer({title, value, formatValue, inverse = false}) {
    const lastValue = useRef(null)
    const [direction, setDirection] = useState(0)
    const [justUpdated, setJustUpdated] = useState(false)
    const timeoutRef = useRef(null)

    useEffect(() => {
        let direction = 0
        if(lastValue.current < value)
            direction = 1
        else if(lastValue.current > value)
            direction = -1 
        
        if(lastValue.current !== null) {
            setDirection(inverse ? -1*direction: direction)
            setJustUpdated(true)        
    
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
            
            timeoutRef.current = setTimeout(() => {
                setJustUpdated(false)
            }, VALUE_CHANGE_TIMEOUT)
        }

        lastValue.current = value
        
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current)
            }
        }
    }, [value, inverse])

    return (
        <p className={!justUpdated ? "" : direction === 0 ? "neutral" : direction > 0 ? "ascending" : "descending"}>
            <strong>{title} </strong>{ formatValue(value)}</p>
    )
}


export default NumericVisualizer